import React from "react";

const FolderXIcon = () => {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M14 35V98C14 105.722 20.2781 112 28 112H112C119.722 112 126 105.722 126 98V45.5C126 37.7781 119.722 31.5 112 31.5H79.3406C77.8313 31.5 76.3438 31.0188 75.1406 30.1L66.7406 23.8C64.3125 21.9844 61.3594 21 58.3406 21H28C20.2781 21 14 27.2781 14 35ZM55.1469 56.8969C57.2031 54.8406 60.5281 54.8406 62.5625 56.8969L69.9781 64.3125L77.3937 56.8969C79.45 54.8406 82.775 54.8406 84.8094 56.8969C86.8438 58.9531 86.8656 62.2781 84.8094 64.3125L77.3937 71.7281L84.8094 79.1437C86.8656 81.2 86.8656 84.525 84.8094 86.5594C82.7531 88.5938 79.4281 88.6156 77.3937 86.5594L69.9781 79.1437L62.5625 86.5594C60.5062 88.6156 57.1813 88.6156 55.1469 86.5594C53.1125 84.5031 53.0906 81.1781 55.1469 79.1437L62.5625 71.7281L55.1469 64.3125C53.0906 62.2562 53.0906 58.9313 55.1469 56.8969Z"
        fill="#9A9A9A"
      />
      <path
        d="M84.8531 64.3343C86.9094 62.278 86.9094 58.953 84.8531 56.9187C82.7969 54.8843 79.4719 54.8624 77.4375 56.9187L70.0219 64.3343L62.6063 56.9187C60.55 54.8624 57.225 54.8624 55.1906 56.9187C53.1562 58.9749 53.1344 62.2999 55.1906 64.3343L62.6063 71.7499L55.1906 79.1655C53.1344 81.2218 53.1344 84.5468 55.1906 86.5811C57.2469 88.6155 60.5719 88.6374 62.6063 86.5811L70.0219 79.1655L77.4375 86.5811C79.4938 88.6374 82.8188 88.6374 84.8531 86.5811C86.8875 84.5249 86.9094 81.1999 84.8531 79.1655L77.4375 71.7499L84.8531 64.3343Z"
        fill="#9A9A9A"
      />
    </svg>
  );
};

export default FolderXIcon;
